import { useLocalizationContext } from '@im/react-localization';
import { NavItem } from '@im/ui-lib/nav';
import { useMemo } from 'react';
import { useSolutionsMenuQuery } from '../../hooks/use-solutionsmenu';
import { buildNavMenuItem } from './utils';

export function useSolutionsNavItems(enabled: boolean) {
  const { locale } = useLocalizationContext();
  const { data: solution } = useSolutionsMenuQuery(locale, enabled);

  return useMemo<NavItem[]>(() => {
    return buildNavMenuItem(solution, locale);
  }, [locale, solution]);
}
